/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import AttributesProxy from 'cio/app-models/customer/attributes-proxy';
import { action } from '@ember/object';

interface Args {
  attributesProxy: AttributesProxy;
}

export default class AttributesComponent extends Component<Args> {
  @action
  removeAttribute(attribute: Record<string, any>) {
    this.args.attributesProxy.remove(attribute as any);
  }

  @action
  hideAttribute(attribute: Record<string, any>) {
    this.args.attributesProxy.hideAttribute(attribute);
  }
}
